import _ from 'lodash';
import { createReducer } from '../../../common/reduxHelpers';
import * as types from './actionTypes';
import { addFormProps, setValue } from './utils';
import { utcToDisplayDate } from '../../../common/formatting';


const emptySearchCriteria = {
    customerId: { touched: false, value: '', original: '' },
    firstName: { touched: false, value: '', original: '' },
    lastName: { touched: false, value: '', original: '' },
    mobilePhone: { touched: false, value: '', original: '' },
    email: { touched: false, value: '', original: '' },
    birthDate: { touched: false, value: '', original: '' },
    deviceSerialNumber: { touched: false, value: '', original: '' },
    externalReference: { touched: false, value: '', original: '' }
};

export const initialState = {
    searchCriteria: emptySearchCriteria,
    searchResults: [],
    isLoading: false,
    isVisible: false
};

const reducer = createReducer(initialState, {
    [types.CUSTOMER_LOOKUP_SUCCESS](state, action) {
        delete state.searchResults;
        let customerViewList = action.response.map(customer => {
            let customerView = _.pick(customer, ["id", "firstName", "lastName", "email", "mobilePhone", "birthDate", "class", "type", "externalReference"]);
            let defaultAddress = _.find(customer.addresses, x => x.addressType === "Default");
            
            return _.assign({}, customerView, _.omit(defaultAddress, ["id"]), { birthDate: utcToDisplayDate(customerView.birthDate) });
        });

        return _.assign({}, state, {
            searchResults: [...customerViewList],
            isLoading: false,
            isVisible: true
        });
    },

    [types.CUSTOMER_LOOKUP_REQUEST](state, action) {
        return _.assign({}, state, { isLoading: true, isVisible: true });
    },

    [types.CUSTOMER_LOOKUP_FAILURE](state, action) {
        return _.assign({}, state, {
            searchResults: [],
            isLoading: false,
            isVisible: true
        });
    },

    [types.BLUR_FIELD](state, action) {
        return _.assign({}, state, {
            searchCriteria: _.assign({}, state.searchCriteria, {
                [action.field]: setValue(state[action.field], action.value)
            })
        });
    },
    [types.CHANGE_FIELD](state, action) {
        return _.assign({}, state, {
            searchCriteria: _.assign({}, state.searchCriteria, {
                [action.field]: setValue(state[action.field], action.value)
            })
        });
    },
    [types.CLEAR_CRITERIA](state, action) {
        return _.assign({}, state, {
            searchCriteria: emptySearchCriteria,
            searchResults: [],
            isVisible: false
        });
    }

});

export default reducer;